import Menu, { Item as MenuItem } from 'rc-menu';

import 'rc-menu/assets/index.css';
import 'rc-dropdown/assets/index.css';
import { cn } from '@/utils/helper';

interface IKeyValue {
  label: string;
  value: string;
}

interface IHelpMenuDropdown {
  categoryHandler: (category: string) => void;
  menu: (string | IKeyValue)[];
  customStyle?: string;
  menuItemClassName?: string;
}

const HelpMenuDropdown: React.FC<IHelpMenuDropdown> = ({ categoryHandler, menu, customStyle, menuItemClassName }) => (
  <Menu className={cn('top-sales-dropdown menu', customStyle ?? '')}>
    {menu.map((item, idx) => {
      const isString = typeof item === 'string';
      return (
        <MenuItem className={cn('!text-input bg-white flex items-center text-xs hover:bg-light-gray', menuItemClassName)} key={idx} onClick={() => categoryHandler(isString ? item : item.value)}>
          {isString ? item : item.label}
        </MenuItem>
      );
    })}
  </Menu>
);
export default HelpMenuDropdown;
